import React, {useEffect, useState} from 'react';
import {Button, Col, Flex, Form, Input, Popover, Select, Steps, StepsProps} from "antd";
import Header from "../../components/header/Header";
import BackGroundLogo from "../../components/adBackGroundLogo/BackGroundLogo";
import {CategoryCard, LocationCard} from "../../components";
import {StyledCard} from "../../components/categoryPopup/CategoryPopup.styled";
import {useForm} from "antd/es/form/Form";
import {AdEditStepOneProps, AdInsertStepOneProps, OnCategoryConfirm} from "../../models";
import TextArea from "antd/es/input/TextArea";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import {connect} from "react-redux";
import {getCities, getProductSubCategoryList, getProvinces, getUserCities} from "../../../../shared";
import {withRouter} from "../../../../utils/services/with-router";
import cities from "../../../../shared/assets/cities";
import styled from "./AInsertStepone.module.scss";
import subCategoryList from "../../../../shared/assets/subCategoryList";
import style from "../adInsertStepTwo/AInsertStepTow.module.scss";
import {StyledSteps} from "../AdInsertSteps.styled";
import {getProductDetail} from "../../../product/actions/Product.action";

const AdEditStepOne = ({getCities,getProductSubCategoryList,getProductDetail}: AdEditStepOneProps) => {
    let navigate = useNavigate();
    let location = useLocation();
    const [form] = useForm();
    const [loading, setLoading] = useState<boolean>(false);
    const [citiesList, setCitiesList] = useState<any[]>([]);
    const [data, setData] = useState<any>();
    const { id } = useParams();
    const domain = "https://peydaa.ir";
    const onFinish = (value: any) => {
        let stepTwoData = {
            productAssurances : data.productAssurances,
            productConditions : data.productConditions.flatMap((condition:any) => condition.detail),
            productProperties : data.productProperties,
            productPricings : data.productPricings,
            productId:data.productId,
        }
    navigate('/ad-edit-step-two/'+id,{state:{
        stepOneForm:value,
        stepTwoForm:location.state?.stepTwoForm ?location.state?.stepTwoForm :stepTwoData,
        stepThreeForm:location.state?.stepThreeForm,
            productImages:data.productImages?.map((item:any) => ({
                ...item,
                url:`${domain}/${item.url}`,
                isUploaded:true
            }))
        }})
    }


    useEffect(() => {

        console.log(location?.state)
    }, [location.state]);
    const _getProductThumbnail = () => {
        setLoading(true);
        getProductDetail(id)
            .then((data: any) => {
                setLoading(false);
                if (data.payload != undefined) {
                    setData(data?.payload?.data)
                    location.state?.stepOneForm ? form.setFieldsValue(location.state.stepOneForm) :
                        form.setFieldValue("cityId" , data.payload.data.city.id)
                        form.setFieldValue("subCategoryId" , data.payload.data.category.subCategoryId)
                        form.setFieldValue("name" , data.payload.data.name)
                        form.setFieldValue("description" , data.payload.data.description)

                }
            })
            .catch((e: any) => {
            });
    };
    const customDot: StepsProps['progressDot'] = (dot, { status, index }) => (
        <Popover
        >
            {dot}
        </Popover>
    );
    useEffect(() => {
        _getProductThumbnail()
    }, []);
    return (
        <Flex vertical gap={"small"}>
            <Header step={1}/>
           <div className={styled.customDiv}>
               <StyledSteps direction={"vertical"}
                      progressDot={customDot}
                   current={0}
                   items={[
                       {
                           title: '1 : اطلاعات آگهی',

                       },
                       {
                           title: '2 : جزئیات آگهی',
                       },
                       {
                           title: '2 : عکس آگهی',
                       },
                   ]}
               />

               <Form form={form} onFinish={onFinish}>
                   <Flex vertical>
                       <Flex vertical align={"middle"}>
                           <Form.Item  name={'cityId'}
                                       rules={[{ required: true, message: "شهر را وارد کنید" }]}
                           >

                               <Select  showSearch
                                        optionFilterProp="children"
                                        filterOption={(input, option) => (option?.label ?? '').includes(input)}

                                        variant={"outlined"} options={cities} size={"large"} placeholder={'شهر'}
                               />
                           </Form.Item>
                           <Form.Item  name={'subCategoryId'}
                                       rules={[{ required: true, message: "دسته بندی را وارد کنید" }]}
                           >

                               <Select
                                   showSearch
                                   optionFilterProp="children"
                                   filterOption={(input, option) => (option?.label ?? '').includes(input)}
                                   options={subCategoryList}  variant={"outlined"}  size={"large"} placeholder={'دسته بندی'}

                               />
                           </Form.Item>
                           <Form.Item  name={'name'}
                                       rules={[{ required: true, message: "عنوان آگهی را وارد کنید" }]}
                           >

                               <Input variant={"outlined"} size={"large"} placeholder={'عنوان آگهی'}
                               />
                           </Form.Item>
                           <Form.Item  name={'description'}
                                       rules={[{ required: true, message: "توضیحات را وارد کنید" }]}
                           >

                               <TextArea variant={"outlined"} rows={4} placeholder={'توضیحات'}
                               />
                           </Form.Item>

                       </Flex>

                       <Flex gap={"small"} className={styled.customBtns}>
                           <Button  htmlType={"submit"} size={"large"} type={"primary"} block> ادامه</Button>
                           <Button onClick={() => navigate(`/myProduct-detail/${id}`)} size={"large"}  block > انصراف</Button>
                       </Flex>
                   </Flex>
               </Form>
           </div>
        </Flex>
    );
};

export default connect(null, {getCities,getProductSubCategoryList,getProductDetail})(withRouter(AdEditStepOne));
